import { render, staticRenderFns } from "./PhotoCroppa.vue?vue&type=template&id=60a87cfe"
import script from "./PhotoCroppa.vue?vue&type=script&lang=js"
export * from "./PhotoCroppa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports